import React from 'react';
import AdminWordlistsContainer from '../components/adminWordlists.container';

/** `/admin/wordlists` — the catalog table across every user. */
const AdminWordlistsPage: React.FC = () => <AdminWordlistsContainer />;

export default AdminWordlistsPage;
